import type { PropsWithChildren, FunctionComponent } from 'react'
import { Suspense } from 'react'
import { RouteSuspenseLoading } from './components/RouteSuspenseLoading'

export const RouteSuspense: FunctionComponent<PropsWithChildren<unknown>> = ({ children }) => (
  <Suspense fallback={<RouteSuspenseLoading />}>{children}</Suspense>
)
